import React, { useState } from 'react'
import Layout from '../component/Layout/Layout'
import './blog.css'
import { Link } from 'react-router-dom'

import { useBlogAPI } from '../hooks/useAllCategoryData';
import parse from "html-react-parser";
import {dateInMDY} from '../Helper'

export default function BlogList() {
     const [pageData, SetPageData] = useState([]);

     const { isLoading, error, data } = useBlogAPI();
     if (error) return <div>{error.message}</div>;

     //console.log(data.posts)
    //  useEffect(()=>{
    // 	document.title = "About US : Chaashni by Maansi & Ketan";
    // });
    return (
        <Layout title="Blog | Chaashni by Maansi & Ketan">
            <div className="site-content-wrap static-page blog-list">
                <div className="container">
                <div className="row">
                    
                </div>
                    {<div className="row">
                    <h1 className="sustom-heading-h1">Blog</h1>
                        {isLoading && (
                           <div className='loading-div'><span>Loading...</span></div>
                        )}
                         {data?.posts?.map((e, i) => ( 
                            <div key={i} className='col-md-4'>                            
                            <div className='blogbox'>
                            <div className='imgbox'><Link to={`/blog/${e.slug}`}><img src={`${process.env.REACT_APP_API_ROOT}/storage/app/public/blog/${JSON.parse(e.images)[0]}`} alt='' /></Link></div>                        
                            <div className='blog-content'>
                                <h2 className='blog-title'><Link to={`/blog/${e.slug}`}>{e.post_title.length > 45 ? e.post_title.substring(0,45) + "..." : e.post_title }</Link></h2>
                                <div className='author'><span className='author-date'><i className="fa-solid fa-calendar-days"></i> {dateInMDY(e.created_at)}</span></div>
                                <p>{data?.posts && parse(`${e.post_content.length > 125 ? e.post_content.substring(0, 130) + "...":e.post_content}`)}</p>
                                <div className='readmore'><Link to={`/blog/${e.slug}`}>Read More <i className="fa fa-arrow-right"></i></Link>                                
                                </div>
                            </div>                       
                            </div>
                            
                        </div> 
                         ))}
                    </div>}
                </div>
            </div>
        </Layout>
    )
}